import { initContract } from "@ts-rest/core";
import { ErrorMessageSchema } from "@common/schemas/error.schema";
import {
    PatIdPathParamsSchema,
    CreatePersonalAccessTokenResponseSchema,
    CreatePersonalAccessTokenSchema,
    ListPersonalAccessTokensResponseSchema,
} from "../schemas/domains/personalAccessToken/personal-access-token.schema";

const c = initContract();

export const personalAccessTokenContract = c.router(
    {
        list: {
            method: "GET",
            path: "",
            responses: {
                200: ListPersonalAccessTokensResponseSchema,
                401: ErrorMessageSchema,
                404: ErrorMessageSchema,
            },
        },
        create: {
            method: "POST",
            path: "",
            body: CreatePersonalAccessTokenSchema,
            responses: {
                201: CreatePersonalAccessTokenResponseSchema,
                400: ErrorMessageSchema,
                401: ErrorMessageSchema,
                403: ErrorMessageSchema,
                404: ErrorMessageSchema,
                429: ErrorMessageSchema,
            },
        },
        revoke: {
            method: "DELETE",
            path: "/:id",
            pathParams: PatIdPathParamsSchema,
            body: c.noBody(),
            responses: {
                200: c.noBody(),
                401: ErrorMessageSchema,
                404: ErrorMessageSchema,
            },
        },
    },
    {
        pathPrefix: "/personal-access-tokens",
    },
);
